import { render, staticRenderFns } from "./ContasAReceber.vue?vue&type=template&id=55c2cdc5&scoped=true&"
import script from "./ContasAReceber.vue?vue&type=script&lang=js&"
export * from "./ContasAReceber.vue?vue&type=script&lang=js&"
import style0 from "./ContasAReceber.vue?vue&type=style&index=0&id=55c2cdc5&prod&lang=scss&scoped=true&"
import style1 from "./ContasAReceber.vue?vue&type=style&index=1&id=55c2cdc5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c2cdc5",
  null
  
)

export default component.exports